/**
 * Cálculo de totales para la vista previa en vivo del constructor.
 *
 * OJO: esto es SÓLO para mostrar mientras se arma la cotización. El importe
 * que vale es el que calcula el backend (QuoteLine::recalculate), que es el
 * que se guarda y el que sale en el PDF. Si alguna vez hay que tocar la
 * fórmula, hay que tocar los dos lados — están replicados a propósito para no
 * tener que pegarle al servidor en cada tecla.
 */
export function lineTotals(line) {
    const qty = Number(line.quantity) || 0;
    const price = Number(line.unit_price) || 0;
    const discount = Number(line.discount_percent) || 0;
    const taxRate = Number(line.tax_rate) || 0;

    const gross = qty * price;
    const taxable = round2(gross - gross * (discount / 100));
    const tax = round2(taxable * (taxRate / 100));

    return { taxable, tax, total: round2(taxable + tax) };
}

export function quoteTotals(lines) {
    return (lines || []).reduce(
        (acc, line) => {
            const { taxable, tax } = lineTotals(line);
            return {
                subtotal: round2(acc.subtotal + taxable),
                totalTax: round2(acc.totalTax + tax),
                total: round2(acc.total + taxable + tax),
            };
        },
        { subtotal: 0, totalTax: 0, total: 0 },
    );
}

function round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function formatMoney(value, currency) {
    const n = Number(value) || 0;
    try {
        return new Intl.NumberFormat('es-ES', {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
        }).format(n);
    } catch {
        // Intl lanza con un código de moneda que no reconoce; no debe tumbar
        // la pantalla entera por un dato mal cargado.
        return `${currency} ${n.toFixed(2)}`;
    }
}
